import "./ai.scss";

import { Link } from "react-router-dom";

import {
  LesionLine,
  subtypeOrSubtypesDiagnosis,
} from "shared/reducers/aiReducer";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { SlideDetailState } from "shared/reducers/slideDetailReducer";

interface AIOutputProps {
  id?: number;
  caseDetailObject: CaseDetailState;
  slideDetailObject: SlideDetailState;
  createdAtDate?: Date;
  updatedAtDate?: Date;
  lesion_lines?: LesionLine[];
}

const AIOutput = (props: AIOutputProps) => {
  const {
    id,
    caseDetailObject,
    slideDetailObject,
    createdAtDate,
    updatedAtDate,
    lesion_lines,
  } = props;

  const caseId = caseDetailObject.id;
  const caseAccession = caseDetailObject.accession;
  const slideId = slideDetailObject.id;

  const count = lesion_lines ? lesion_lines.length : 0;
  let lesionLabel = "NO LESION LINES FOUND.";
  if (count) {
    lesionLabel = `${count} LESION LINE${count === 1 ? "" : "S"} FOUND.`;
  }

  return (
    <div className="AIOutput">
      <div className="inner_header">
        <p>
          {caseId ? (
            <>
              <div>
                Case ID: <em>{caseId}</em>
              </div>
              <div>
                <Link to={`/cases/${caseId}/`}>
                  <em>Accession # {caseAccession}</em>
                </Link>
              </div>
            </>
          ) : undefined}
        </p>
        <p className="spacer">
          <div>
            Classification ID: <em>{id}</em>
          </div>
          <div>
            {createdAtDate ? `Created: ${createdAtDate.toLocaleString()}` : ""}
          </div>
          <div>
            {updatedAtDate ? `Updated: ${updatedAtDate.toLocaleString()}` : ""}
          </div>
          <div>
            <em>{lesionLabel}</em>
          </div>
        </p>
        <p>
          <div>
            Slide ID: <em>{slideId}</em>
          </div>
          <div>
            <Link
              to={
                caseId
                  ? `/cases/${caseId}/slides/${slideId}/`
                  : `/slide/${slideId}`
              }
            >
              <em>
                Block {slideDetailObject.block_obj?.name} / Slide{" "}
                {slideDetailObject.slide_number}
              </em>
            </Link>
          </div>
        </p>
      </div>
      <div>
        {lesion_lines && lesion_lines.length > 0 ? (
          lesion_lines.map((line, i) => (
            <div className="lesion_line">
              <div>
                <em>LESION LINE {i + 1}:</em>
              </div>
              <hr />
              <div>ID: {line.id}</div>
              <div>Name: {line.diagnosis_name}</div>
              <div>Diagnosis Result: {line.diagnosis_result}</div>
              <div>WSI LVL Prediction: {line.wsi_lvl_prediction}</div>
              <div>Subtype: {subtypeOrSubtypesDiagnosis(line) || "null"}</div>
            </div>
          ))
        ) : (
          <div>NO LESION LINES IDENTIFIED.</div>
        )}
      </div>
    </div>
  );
};

export default AIOutput;
